import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "create-document-box-wrapper" }
const _hoisted_2 = { class: "create-document-box" }
const _hoisted_3 = { class: "document-name-input-wrapper" }
const _hoisted_4 = { for: "document-name" }
const _hoisted_5 = {
  key: 0,
  class: "p-1 mt-10 text-error"
}
const _hoisted_6 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_7 = { class: "create-card-wrapper mr-24" }
const _hoisted_8 = { class: "create-card-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_back_svg = _resolveComponent("back-svg")!
  const _component_PlusSvg = _resolveComponent("PlusSvg")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_template_svg = _resolveComponent("template-svg")!
  const _component_new_card = _resolveComponent("new-card")!
  const _component_document_svg = _resolveComponent("document-svg")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, { "no-sidebar": true }, {
    "header-left": _withCtx(() => [
      _createElementVNode("div", {
        class: "heading-4 heading-4 f-roboto fw-light d-flex cursor-p",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'dashboard' }))),
        onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$router.push({ name: 'dashboard' })), ["enter"]))
      }, [
        _createVNode(_component_back_svg, { class: "mr-6" }),
        _cache[4] || (_cache[4] = _createElementVNode("div", null, "Back to dashboard", -1))
      ], 32)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.isOnFirstStep)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_2, [
                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "" }, "Name of new partner?", -1)),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("label", _hoisted_4, [
                    _withDirectives(_createElementVNode("input", {
                      id: "document-name",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.name) = $event)),
                      class: "base-input",
                      type: "text",
                      placeholder: "Your Answer",
                      onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.toSecondStep && _ctx.toSecondStep(...args)), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.name]
                    ])
                  ])
                ]),
                (_ctx.createDocumentError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.createDocumentError), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass({ 'create-button-wrapper': true, 'is-visible': _ctx.isNameValidForSubmit })
              }, [
                _createVNode(_component_base_button, { onHandleClick: _ctx.toSecondStep }, {
                  default: _withCtx(() => [
                    _createVNode(_component_PlusSvg, { class: "white" }),
                    _cache[6] || (_cache[6] = _createTextVNode()),
                    _cache[7] || (_cache[7] = _createElementVNode("span", null, "Create EPX Document", -1))
                  ]),
                  _: 1
                }, 8, ["onHandleClick"])
              ], 2)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.isOnSecondStep)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_new_card, {
                  name: "Use standard questions",
                  "card-background": "red",
                  onHandleClick: _ctx.createDocumentWithStandardQuestion
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_template_svg)
                  ]),
                  _: 1
                }, 8, ["onHandleClick"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_new_card, {
                  name: "Create a new questions",
                  onHandleClick: _ctx.createDocument
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_document_svg)
                  ]),
                  _: 1
                }, 8, ["onHandleClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}